import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]

import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import { themingCssClasses } from "vue/applications/frontend/mixins/theming-mixin"
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-rich_text',
  props: {...cntProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["components__cnt-richt_text", _unref(themingCssClasses)(['sub_headline', 'sub_link'])])
  }, [
    (_ctx.contentItem)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: _ctx.contentItem.widget_data.content
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})